import { authClient } from "@/api/auth-client";
import { env } from "@/env";
import { ImpersonationBanner } from "@/features/admin";
import { NotificationBell } from "@/features/notifications";
import { ThemeToggle } from "@/features/theme";
import { CommandPalette } from "@/shared/components/command-palette";
import { AppShell } from "@/shared/layout";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async () => {
    const session = await authClient.getSession();
    if (!session.data?.session) {
      throw redirect({ to: "/login" });
    }

    // Evidence-only accounts (appAccess === false) may still hold a cookie but
    // must never render the dashboard shell. The API rejects them too — this is
    // defense in depth at the route boundary. A network error is non-fatal.
    let evidenceOnly = false;
    try {
      const res = await fetch(`${env.VITE_API_URL}/api/trpc/auth.getSession`, {
        credentials: "include",
      });
      if (res.ok) {
        const body = (await res.json()) as {
          result?: { data?: { profile?: { appAccess?: unknown } | null } };
        };
        evidenceOnly = body.result?.data?.profile?.appAccess === false;
      }
    } catch {
      evidenceOnly = false;
    }
    if (evidenceOnly) {
      // Odhlásíme (smažeme Better Auth cookie), jinak by _auth guard poslal
      // platnou session hned zpět na /dashboard → redirect smyčka.
      await authClient.signOut().catch(() => undefined);
      throw redirect({ to: "/login" });
    }
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <ImpersonationBanner />
      <CommandPalette />
      <div className="min-h-0 flex-1">
        <AppShell
          topBarActions={
            <>
              <NotificationBell />
              <ThemeToggle />
            </>
          }
        >
          <Outlet />
        </AppShell>
      </div>
    </div>
  );
}
